import React from "react";
import {
  Box
} from "@mui/material";

import Header from "./Header";
import Highlights from "./Highlights";
import CallToAction from "../../call_to_action/CallToAction";
import About from "./About";
import ContactsAndRegistration from "./ContactsAndRegistration";
import IntramuralPrograms from "./IntramuralPrograms";

export default function IntramuralTest() {
  return (
      <Box sx={{ bgcolor: "background.default", color: "#e9eef6" }}>
        <Header/>
        <About/>
        <Highlights/>
        <IntramuralPrograms/>
        <ContactsAndRegistration/>
      </Box>
  );
}